<main class="main">

  <header class="py-0 to-screen">
      <div class="d-flex flex-wrap fixed-top bg-white shadow-sm" style="height:54px">
          <div class="visually-hidden-focusable overflow-hidden">
              <a class="d-inline-flex p-2 m-1 text-dark text-decoration-none" href="#content">Skip to main content</a>
              <a class="d-none d-lg-inline-flex p-2 m-1 text-dark text-decoration-none" href="#navigation">Skip to navigation</a>
          </div>
          <a class="uofs-header-logo text-dark text-decoration-none border-end" href="https://usask.ca">
                  <img alt="University of Saskatchewan" class="d-none d-sm-block" height="32px" src="assets/img/uofs-logo.webp">
                  <img alt="University of Saskatchewan" class="d-block d-sm-none" height="32px" src="assets/img/uofs-crest.webp">
          </a>
          <a class="m-0 h5 fw-bolder text-decoration-none me-auto uofs-header" href="">Financial Planning Estimator</a>
      </div>
  </header>
</main>

<app-tuition-form></app-tuition-form>
<router-outlet />
